import React from "react";
import ReactApexChart from "react-apexcharts";
import "./styles/dashboard.css";

const SalesOverviewGraph = ({ series = [], labels = [] }) => {
  const options = {
    chart: {
      height: 300,
      type: "line",
      toolbar: {
        show: false,
      },
    },
    stroke: {
      width: [0, 2],
      curve: "smooth",
    },
    markers: {
      size: [0, 6],
      colors: ["#FFFFFF"],
      strokeColors: "#EF4444",
      strokeWidth: 2,
      hover: {
        size: 7,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 6,
        columnWidth: "40px",
      },
    },
    colors: ["#3B82F6", "#EF4444"],
    dataLabels: {
      enabled: false,
    },
    labels: labels,
    xaxis: {
      labels: {
        style: {
          colors: "#6B7280",
          fontSize: "12px",
          fontWeight: 500,
        },
      },
    },
    yaxis: {
      min: 0,
      max: 32,
      tickAmount: 5,
      labels: {
        style: {
          colors: "#9CA3AF",
          fontSize: "12px",
        },
      },
    },
    grid: {
      borderColor: "#E5E7EB",
      strokeDashArray: 5,
    },
    legend: {
      show: false,
    },
  };

  return (
    <div style={{ padding: "0" }}>
      <ReactApexChart
        options={options}
        series={series}
        type="line"
        height={300}
      />
    </div>
  );
};

export default SalesOverviewGraph;
